<template>
  <footer :class="showFooter ? '' : 'hidden'">
    <p>{{ fullDate(currentDay) }}</p>
    <div></div>
    <div></div>
    <div></div>
  </footer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Footer',
  props: {
    showFooter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      currentDay: state => state.calendar.currentDay,
    }),
    ...mapGetters([
      'fullDate',
    ]),
  }
}
</script>

<style scoped>
footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 0 50px 0 50px;
  background: var(--primary-color);
  display: flex;
  height: 35px;
  align-items: center;
  z-index: 5;
  transition: transform 1s;
  box-shadow: 0px 0px 50px var(--secondary-color);
}

footer > p {
  color: var(--secondary-color);
  font-size: 12px;
}

.hidden {
  transform: translate(0, 70px);
}

/* footer animation */
@keyframes pulse {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

footer > div {
  background-color: var(--tertiary-color);
  position: absolute;
  box-shadow: 0 0 15px var(--tertiary-color);
  border-radius: 100%;
  bottom: 13px;
  width: 8px;
  height: 8px;
  animation: 3s ease-in-out infinite alternate pulse;
}

footer > div:nth-child(2) {
  right: 15px;
  animation-delay: -0.5s;
}
footer > div:nth-child(3) {
  right: 30px;
  animation-delay: -1s;
}
footer > div:nth-child(4) {
  right: 45px;
  animation-delay: -1.5s;
}
</style>
